<script>
	import { byTraitLabelWidthSorter } from './helpers.js';
	import { getNewIcon } from '../card_images';
	import { afterUpdate } from 'svelte';
	import AwayTeamBadge from './header/AwayTeamBadge.svelte';
	import SkillBadge from './header/SkillBadge.svelte';
	import TitleLabel from './header/TitleLabel.svelte';
	import TraitBadge from './header/TraitBadge.svelte';
	import TreacherySkillBadge from './header/TreacherySkillBadge.svelte';
	import "./shared.css";

	export let name;
	export let suit;
	export let traits = [];
	export let skills = [];
	export let awayTeams = undefined;
	export let drones = undefined;

	let orderedTraits = traits;
	afterUpdate(() => {
		orderedTraits = traits.sort(byTraitLabelWidthSorter);
	});
	$: suitLabel = suit === 'qsuit' ? 'Q' : suit;

	let standardSkills;
	let treacherySkill;

	$: standardSkills = skills.filter((x) => x !== 'treachery');
	$: treacherySkill = skills.filter((x) => x === 'treachery').length;
</script>

<div class="header">
	<div class="header-left">
		<TitleLabel label={name} {suit} />
		<TitleLabel label={suitLabel} {suit}>
			<img src={getNewIcon(suit)} slot="icon"/>
		</TitleLabel>

		{#if awayTeams || drones}
			<div style="height: 5px;" />
		{/if}

		{#if awayTeams}
			<AwayTeamBadge {awayTeams} />
		{:else if drones}
			<AwayTeamBadge isBorg={true} awayTeams={drones} />
		{/if}

		{#if skills.length > 0}
			<div style="height: 5px;" />
		{/if}

		{#if treacherySkill > 0}
			<TreacherySkillBadge value={treacherySkill} />
		{/if}

		{#each skills as skill}
			<SkillBadge {skill} />
		{/each}
	</div>
	<div class="header-right">
		{#each traits.sort(byTraitLabelWidthSorter) as trait, index}
			<TraitBadge {index} {trait} />
		{/each}
	</div>
</div>

<style>
	.header {
		flex-direction: row;
		padding-top: 3.5%;
		padding-right: 3.5%;
	}
	.header-left {
		flex-direction: column;
		flex-grow: 1;
		gap: calc(var(--width) / 143.5); /*2px;*/
		min-width: 0;
	}
	.header-right {
		flex-direction: row-reverse;
		justify-content: flex-end;
		flex-shrink: 0;
		margin-left: calc(var(--width) / 28.7); /*10px;*/
	}
</style>
